import React from 'react';
import { FormattedMessage, defineMessages } from 'react-intl';
import ConfirmDialog from './ConfirmDialog';

const messages = defineMessages({
  title: {
    id: 'unsaved_changes_dialog.you_have_unsaved_changes',
    defaultMessage: 'You have unsaved changes',
  },
  description: {
    id: 'unsaved_changes_dialog.continue_anyway',
    defaultMessage: 'Your changes will not be saved.',
  },
  cancel: {
    id: 'unsaved_changes_dialog.cancel',
    defaultMessage: 'Cancel',
  },
  ok: {
    id: 'unsaved_changes_dialog.ok',
    defaultMessage: 'Ok',
  },
});

interface UnsavedChangesDialogProps {
  open: boolean;
  onCancel: () => void;
  onOk: () => void;
}

const UnsavedChangesDialog: React.FC<UnsavedChangesDialogProps> = ({
  open,
  onOk,
  onCancel,
}) => {
  return (
    <ConfirmDialog
      open={open}
      onConfirm={onOk}
      onCancel={onCancel}
      titleLabel={<FormattedMessage {...messages.title} />}
      confirmLabel={<FormattedMessage {...messages.ok} />}
      cancelLabel={<FormattedMessage {...messages.cancel} />}
    >
      <FormattedMessage {...messages.description} />
    </ConfirmDialog>
  );
};

export default UnsavedChangesDialog;
